import { deletePaymentRemittanceType } from "../../../../../actions/Utilities/PaymentRemittanceType";
import { useMutation, useQueryClient } from "react-query";
import { toast } from "../../../../../components/toastNotification";

const useDeletePaymentRemittanceType = () => {
  const queryClient = useQueryClient();

  const { mutate } = useMutation(
    ( ids: number[] | undefined ) => deletePaymentRemittanceType(ids), {
    onSuccess: () => {
      queryClient.invalidateQueries(["GetPaymentRemittanceType"]);
      toast.fire(
        "Success",
        "Payment Remittance Type were deactivated successfully",
        "success"
      );
    },
    onError: () => {
      toast.fire(
        "Bulk deactivation of Payment Remittance Type failed",
        "Server Error: Cannot deactivate Payment Remittance Type",
        "error"
      );
    },
  });

  return mutate;
};

export default useDeletePaymentRemittanceType;
